module.exports = __webpack_public_path__ + "img/RedteaSIM_ZH04.bd1e049b.jpg";